import { render, staticRenderFns } from "./index.vue?vue&type=template&id=7908b651&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=7908b651&prod&lang=less&scoped=true"
import style1 from "./index.vue?vue&type=style&index=1&id=7908b651&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_8232951c094a308219af544e98f117f1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7908b651",
  null
  
)

export default component.exports